import { useCallback, useEffect, useState } from 'react'
import {
  getMyGoals,
  getMySaver,
  type ApiGoalBucket,
  type ApiSaver,
  upsertGoals,
  upsertMySaver,
} from '@/lib/api'

export function useSavings() {
  const [goals, setGoals] = useState<ApiGoalBucket[]>([])
  const [saver, setSaver] = useState<ApiSaver | null>(null)

  useEffect(() => {
    Promise.all([getMyGoals(), getMySaver()])
      .then(([goalBuckets, saverRow]) => {
        setGoals(goalBuckets)
        setSaver(saverRow)
      })
      .catch(() => {})
  }, [])

  const goalTotal = goals.reduce((sum, bucket) => sum + bucket.amount, 0)
  const savingsAmount = saver?.amount ?? 0
  const progress = goalTotal > 0 ? savingsAmount / goalTotal : 0
  const remaining = Math.max(0, goalTotal - savingsAmount)

  const upsertGoalAmounts = useCallback(async (amounts: { name: string; amount: number }[]) => {
    const updated = await upsertGoals(amounts)
    setGoals(updated)
  }, [])

  const upsertSavingsAmount = useCallback(async (amount: number) => {
    const updated = await upsertMySaver({ amount })
    setSaver(updated)
  }, [])

  return {
    goals,
    saver,
    goalTotal,
    savingsAmount,
    progress,
    remaining,
    upsertGoalAmounts,
    upsertSavingsAmount,
  }
}
